// import React from "react";
// import { useDashboard } from "../api/api-hooks";
// import { useNavigate } from "react-router-dom";
// import DateFilterForm from "../common/DateFilterForm";
// import useCommonStore from "../store/CommonStore";

// function Dashboard() {
//   const {
//     data: status,
//     isLoading: isStatusLoading,
//     error: statusError,
//   } = useDashboard();

//   const { selectedValue, setSelectedValue, customRange, setCustomRange } =
//     useCommonStore();

//   if (isStatusLoading) {
//     return <div>Loading...</div>;
//   }

//   if (statusError) {
//     return <div>Error fetching data: {statusError.message}</div>;
//   }

//   return (
//     <div className="flex flex-col gap-6 w-full max-w-7xl">
//       <h1 className="text-2xl font-bold">Dashboard</h1>

//       <div className="w-full">
//         <DateFilterForm
//           selectedValue={selectedValue}
//           setSelectedValue={setSelectedValue}
//           customRange={customRange}
//           setCustomRange={setCustomRange}
//         />
//       </div>
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
//         {status && (
//           <>
//             <InfoCard title="Total Users" count={status.total_users || 0} />
//             <InfoCard title="Total Chats" count={status.total_chats || 0} />
//             <InfoCard
//               title="Total Projects"
//               count={status.total_projects || 0}
//             />
//             <InfoCard
//               title="Total Research"
//               count={status.total_researches || 0}
//             />
//             <InfoCard title="Active Sessions" count={0} />
//             <InfoCard title="Inactive Users" count={0} />
//             <InfoCard title="Active Users" count={0} />
//             <InfoCard title="Active Chats" count={0} />
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// interface InfoCardProps {
//   title: string;
//   count: number;
// }

// function InfoCard({ title, count }: InfoCardProps) {
//   const navigate = useNavigate();

//   const handleRedirect = () => {
//     const routes: Record<string, string> = {
//       "Total Users": "/users",
//       "Total Chats": "/chats",
//       "Total Projects": "/projects",
//       "Total Research": "/research",
//       "Active Sessions": "/session",
//       "Inactive Users": "/users?status=inactive",
//       "Active Users": "/users?status=active",
//       "Active Chats": "/chats?status=active",
//     };
//     navigate(routes[title] || "/");
//   };

//   return (
//     <div
//       className="w-full border rounded-md flex p-5 gap-5 items-center shadow bg-white cursor-pointer"
//       onClick={handleRedirect}
//     >
//       <div className="bg-indigo-100 h-16 w-16 rounded-md flex justify-center items-center">
//         {/* Add an icon or text here if needed */}
//       </div>
//       <div className="flex flex-col justify-between h-16">
//         <h3 className="text-sm tracking-wide uppercase text-gray-700 font-semibold">
//           {title}
//         </h3>
//         <div className="font-extrabold text-4xl">{count}</div>
//       </div>
//     </div>
//   );
// }

// export default Dashboard;

import { useNavigate } from "react-router-dom";
import { useAdminData } from "../../lib/useAdminData";
import useCommonStore from "../../store/CommonStore";
import DateFilterForm from "../../common/DateFilterForm";
import {
  // filterDataByDate,
  getDateRangeFromSelectedValue,
} from "../../common/Constants";
import UserRegistrationChart from "./charts/UserRegistrationChart";
import DoughnutChart from "./charts/DoughnutChart";
import TopCountriesChart from "./charts/TopCountriesChart";
import TechnologyChart from "./charts/TechnologyChart";
import UserDemo from "./UserDemo";
import {
  useDashboard,
  useSessionsPage,
  useUsersPage,
} from "../../api/api-hooks";
import { usePagination } from "../hooks/usePagination";
import { IconType } from "react-icons";
import { MdOutlineSupervisorAccount } from "react-icons/md";
import TrendChart from "./charts/TrendChart";
import { useMemo, FC } from "react";

function Dashboard() {
  const {
    users: usersData,
    projects,
    chats,
    hrChats,
    sessions,
    // activeChats,
    activeUsers,
    feedbacks,
    inactiveUsers,
    // activeSessions,
    // isLoading,
    // error,
    loadingStates,
    // errorStates,
  } = useAdminData();

  const { selectedValue, setSelectedValue, customRange, setCustomRange } =
    useCommonStore();

  const dateRange = getDateRangeFromSelectedValue(selectedValue);

  const isAllData = dateRange?.isAllData ?? false;
  const startDate = isAllData ? undefined : dateRange?.startDate ?? "";
  const endDate = isAllData ? undefined : dateRange?.endDate ?? "";

  const { data, isLoading }: any = useDashboard({
    startDate,
    endDate,
    isAllData,
  });

  // const { startDate, endDate } = dateRange!;

  // Then use this properly in API calls

  const { pageIndex, pageSize } = usePagination();

  const {
    data: activeSessions,
    isLoading: isSessionLoading,
    // error: chatsError,
  } = useSessionsPage(pageIndex + 1, pageSize, startDate, endDate, isAllData);

  const {
    data: users,
    // isLoading: isUserLoading,
    // error: chatsError,
  } = useUsersPage(pageIndex + 1, pageSize, startDate, endDate, "", isAllData);
  // if (isLoading) {
  //   return (
  //     <div>
  //       <Loader />
  //     </div>
  //   );
  // }

  // if (errorStates) {
  //   return <div>Error fetching data: </div>;
  // }

  return (
    <div className="flex flex-col gap-6 w-full max-w-6xl">
      <div className="w-full flex justify-between border-b border-gray-400 p-4">
        <h1 className="text-2xl w-full font-bold">Dashboard</h1>

        <div className="w-1/3  flex items-center justify-end  ">
          <DateFilterForm
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            customRange={customRange}
            setCustomRange={setCustomRange}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-5 px-4">
        {/* {(users || projects || chats) && ( */}
        <>
          <InfoCard
            title="Newly Registered Users"
            filteredData={usersData?.items}
            data={data?.total_users}
            loadingStates={loadingStates?.isUsersLoading}
            loading={isLoading}
            imgPath="/admin/registered-user.svg"
          />
          <InfoCard
            title="Total Chats"
            filteredData={chats?.items}
            data={data?.total_chats}
            loadingStates={loadingStates?.isChatsLoading}
            loading={isLoading}
            imgPath="/admin/chat.svg"
          />

          <InfoCard
            title="HR Agents"
            filteredData={hrChats?.items}
            data={data?.total_chat_hr}
            loadingStates={loadingStates?.isHrChatsLoading}
            loading={isLoading}
            icon={MdOutlineSupervisorAccount}
          />

          <InfoCard
            title="Total Projects"
            filteredData={projects?.items}
            data={data?.total_projects}
            loadingStates={loadingStates?.isProjectsLoading}
            loading={isLoading}
            imgPath="/admin/project.svg"
          />
          <InfoCard
            title="Total Feedbacks"
            filteredData={feedbacks?.items}
            data={data?.total_feedback}
            loadingStates={loadingStates?.isFeedbackLoading}
            loading={isLoading}
            imgPath="/admin/research.svg"
          />
          <InfoCard
            title="Active Sessions"
            filteredData={sessions?.Sessions}
            data={data?.active_session}
            loadingStates={loadingStates?.isSessionLoading}
            loading={isLoading}
            imgPath="/admin/active-session.svg"
          />
          {/* <InfoCard
            title="Active Chats"
            // data={activeChats}
            data={data?.active_chats}
            // loading={loadingStates?.isChatsLoading}
            loading={isLoading}
            imgPath="/admin/active-chat.svg"
          /> */}
          <InfoCard
            title="Active Users"
            filteredData={activeUsers?.items}
            data={data?.active_user}
            loadingStates={loadingStates?.isActiveUsersLoading}
            loading={isLoading}
            imgPath="/admin/active-user.svg"
          />

          <InfoCard
            title="Inactive Users"
            filteredData={inactiveUsers?.items}
            data={data?.inactive_user}
            loadingStates={loadingStates?.isInactiveUsersLoading}
            loading={isLoading}
            imgPath="/admin/inactive-user.svg"
          />
        </>
        {/* )} */}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 px-4">
        <div className="">
          <DoughnutChart data={activeSessions} isLoading={isSessionLoading} />
        </div>
        <div className="">
          <UserRegistrationChart data={users?.items} />
        </div>
      </div>

      <div className="grid gap-5 px-4">
        <UserDemo />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 px-4">
        <div className="">
          <TopCountriesChart data={activeSessions} />
        </div>
        <div className="">
          <TechnologyChart data={activeSessions} />
        </div>
      </div>
      <div className="grid grid-cols-1 px-4">
        <div className="rounded-lg bg-white border shadow-sm overflow-hidden">
          <AgentUsageChart agents_usage={data?.hr_agent} />
        </div>
      </div>
    </div>
  );
}

interface InfoCardProps {
  title: string;
  data: any;
  loading: boolean;
  imgPath?: string;
  icon?: IconType;
  filteredData: any;
  loadingStates?: boolean;
}

function InfoCard({
  title,
  data,
  loading,
  imgPath,
  icon,
  filteredData,
  loadingStates,
}: InfoCardProps) {
  const navigate = useNavigate();

  // const { selectedValue } = useCommonStore();

  const Icon = icon;

  // const {
  //   filteredData,
  //   // newlyRegisteredUsers,
  //   // totalRegisteredUsers,
  //   // isNewUsers,
  // } = useMemo(() => {
  //   return filterDataByDate(data, selectedValue);
  // }, [data, selectedValue]);

  // let calculatedLength = 0;

  // if (title === "Total Registered Users" && isNewUsers) {
  //   title = "Newly Registered Users";
  //   calculatedLength = newlyRegisteredUsers?.length || 0;
  // } else if (title === "Newly Registered Users" && !isNewUsers) {
  //   title = "Total Registered Users";
  //   calculatedLength = totalRegisteredUsers?.length || 0;
  // } else {
  //   calculatedLength = filteredData?.length || 0;
  // }

  // let calculatedLength = 0;

  // if (title === "Total Registered Users" && isNewUsers) {
  //   title = "Newly Registered Users";
  //   calculatedLength = newlyRegisteredUsers?.length || 0;
  // } else if (title === "Newly Registered Users" && !isNewUsers) {
  //   title = "Total Registered Users";
  //   calculatedLength = totalRegisteredUsers?.length || 0;
  // } else if (
  //   title === "Active Sessions" ||
  //   title === "Active Users" ||
  //   title === "Inactive Users"
  // ) {
  //   const list = Array.isArray(data?.items)
  //     ? data.items
  //     : Array.isArray(data?.Sessions)
  //     ? data.Sessions
  //     : Array.isArray(data)
  //     ? data
  //     : [];

  //   const expectedStatus = title === "Inactive Users" ? "Inactive" : "Active";

  //   calculatedLength = list.filter(
  //     (item: any) => item.status === expectedStatus
  //   ).length;
  // } else if (typeof data?.total === "number") {
  //   calculatedLength = data.total;
  // } else if (Array.isArray(data?.items)) {
  //   calculatedLength = data.items.length;
  // } else if (Array.isArray(data)) {
  //   calculatedLength = data.length;
  // }

  const handleRedirect = () => {
    const routes: Record<string, string> = {
      "Newly Registered Users": "/users?new_user=true",
      "Total Registered Users": "/users",
      "Total Chats": "/chats?agent=false",
      "Total Projects": "/projects",
      // "Total Research": "/research",
      "Total Feedbacks": "/feedback",
      "Active Sessions": "/sessions?status=active",
      "Inactive Users": "/users?status=inactive",
      "Active Users": "/users?status=active",
      // "Active Chats": "/chats?status=active",
      "HR Agents": "/chats?agent=true",
    };
    navigate(routes[title] || "/");
  };

  return (
    // <div
    //   className="w-full border rounded-lg flex flex-col p-4 bg-white cursor-pointer hover:outline hover:outline-2 hover:outline-[#3F81FE]"
    //   onClick={handleRedirect}
    // >
    //   <div className=" space-y-2">
    //     <div>
    //       <img src={imgPath} alt="" className="w-6 h-6" />
    //     </div>

    //     <h3 className="capitalize text-[#323232] font-medium">{title}</h3>
    //   </div>
    //   <div className=" flex items-center w-full justify-between ">
    //     <div className="font-bold text-4xl leading-[56px]">
    //       {loading ? <SkeletonLoader /> : calculatedLength}
    //     </div>
    //     {/* <img src="/icons/dash-trend.svg" alt="graph" className="h-8 w-32" /> */}
    //     <div className="h-8 w-32">
    //       <TrendChart filteredData={filteredData} />
    //     </div>
    //   </div>
    // </div>

    <div
      className="w-full border rounded-lg flex flex-col p-4 bg-white cursor-pointer hover:outline hover:outline-2 hover:outline-[#3F81FE]"
      onClick={handleRedirect}
    >
      <div className="space-y-2">
        {/* <img src={imgPath} alt="" className="w-6 h-6" /> */}
        {Icon ? (
          <Icon className="w-6 h-6 text-gray-500" />
        ) : (
          imgPath && <img src={imgPath} alt="" className="w-6 h-6" />
        )}
        <h3 className="capitalize text-[#323232] font-medium">{title}</h3>
      </div>
      <div className="flex items-center w-full justify-between">
        <div className="font-bold text-4xl leading-[56px]">
          {loading ? <SkeletonLoader /> : data}
        </div>
        <div className="h-8 w-32 flex justify-end items-center">
          <TrendChart
            filteredData={filteredData}
            loadingStates={loadingStates}
          />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

const SkeletonLoader = () => {
  return (
    <div className="w-16 h-[36px] mt-2 bg-gray-300 animate-pulse rounded-md" />
  );
};


// Accept both shapes from the API
type AgentsUsageObj = Record<string, { count: number; percentage?: number }>;
type AgentsUsageNum = Record<string, number>;
type AgentsUsageAny = AgentsUsageObj | AgentsUsageNum;

const AgentUsageChart: FC<{ agents_usage?: AgentsUsageAny }> = ({
  agents_usage,
}) => {
  // Normalize to [agent, {count, percentage?}][]
  const rows = useMemo(() => {
    const entries = Object.entries(agents_usage ?? {});
    return entries
      .map<[string, { count: number; average_usage?: number }]>(([agent, v]) =>
        typeof v === "number" ? [agent, { count: v }] : [agent, v]
      )
      .sort((a, b) => (b[1].count ?? 0) - (a[1].count ?? 0));
  }, [agents_usage]);

  const total = rows.reduce((sum, [, v]) => sum + (v.count ?? 0), 0) || 1;

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-medium text-gray-900">HR Agent Usage</h3>
        <span className="text-sm text-gray-500">{total} total uses</span>
      </div>

      <div className="space-y-4">
        {rows.map(([agent, { count, average_usage }]) => {
          // Use API percentage if provided; otherwise compute it
          const pct = average_usage ?? Math.round(((count ?? 0) / total) * 100);

          return (
            <div key={agent} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-900">{agent}</span>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <span>{count ?? 0} uses</span>
                  <span className="text-gray-400">•</span>
                  <span>{pct}%</span>
                </div>
              </div>
              <div className="h-2 w-full rounded bg-gray-200 overflow-hidden">
                <div
                  className="h-full bg-gray-600 transition-all duration-500"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
